import React from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from 'antd';
import { Popup } from '_atoms';
import { Typography } from '_atoms/Typography';
import './style.scss';

const FORM_NAME = 'form-close-promotion-request';

interface PopupClosePromotionRequestProps {
  open: boolean;
  requestTitle: string;
  loading?: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

export const PopupClosePromotionRequest: React.FC<PopupClosePromotionRequestProps> = ({
  open,
  requestTitle,
  loading,
  onClose,
  onSubmit,
}) => {
  const { t } = useTranslation();

  return (
    <Popup
      className="popup-close-promotion-request"
      open={open}
      title={t('translation:promotion_request_details.title_close')}
      onClose={onClose}
      cancelButtonProps={{ onClick: onClose, children: t('translation:promotion_request_details.button_cancel') }}
      okButtonProps={{
        children: t('translation:promotion_request_details.button_close_request'),
        form: FORM_NAME,
        htmlType: 'submit',
        loading,
      }}
    >
      <Typography.Text className="popup-close-promotion-request__text">
        {t('translation:promotion_request_details.text_close_prefix')} <strong>{requestTitle}</strong>{' '}
        {t('translation:promotion_request_details.text_close_suffix')}
      </Typography.Text>
      <Form name={FORM_NAME} onFinish={onSubmit} />
    </Popup>
  );
};
